const _sfc_main = {
  name: "NcVNodes",
  props: {
    /**
     * The vnodes to render
     */
    vnodes: {
      type: [Array, Object],
      default: null
    }
  },
  /**
   * The render function to display the component
   *
   * @return {object} The created VNode
   */
  render() {
    return this.vnodes || this.$slots?.default?.({});
  }
};
export {
  _sfc_main as default
};
